import {
	type OptimisticUiMeta,
	type OptimisticUiMetaWithFlag,
	beginOptimisticUiMeta,
	commitOptimisticUiMeta,
	revertOptimisticUiWithFlagMeta,
} from '../../meta/optimistic-ui-meta';

export const CARDS_PARENT_SET_OPTIMISTIC =
	'state.actions.cards.parent.CARDS_PARENT_SET_OPTIMISTIC' as const;

type CardsParentSetOptimisticPayload = {
	cards: { id: number }[];
	parentId: number | null;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	requestPromise: Promise<any>;
};

export type CardsParentSetOptimisticAction = {
	type: typeof CARDS_PARENT_SET_OPTIMISTIC;
	payload: CardsParentSetOptimisticPayload;
	meta: OptimisticUiMeta;
};

export const cardsParentSetOptimistic = (
	payload: CardsParentSetOptimisticPayload,
): CardsParentSetOptimisticAction => ({
	type: CARDS_PARENT_SET_OPTIMISTIC,
	payload,
	meta: {
		...beginOptimisticUiMeta(),
	},
});

export const CARDS_PARENT_SET_SUCCESS =
	'state.actions.cards.parent.CARDS_PARENT_SET_SUCCESS' as const;

type CardsParentSetSuccessPayload = {
	cards: { id: number }[];
};

export type CardsParentSetSuccessAction = {
	type: typeof CARDS_PARENT_SET_SUCCESS;
	payload: CardsParentSetSuccessPayload;
	meta: OptimisticUiMeta;
};

export const cardsParentSetSuccess = (
	optimisticId: string,
	payload: CardsParentSetSuccessPayload,
): CardsParentSetSuccessAction => ({
	type: CARDS_PARENT_SET_SUCCESS,
	payload,
	meta: commitOptimisticUiMeta(optimisticId),
});

export const CARDS_PARENT_SET_FAILURE =
	'state.actions.cards.parent.CARDS_PARENT_SET_FAILURE' as const;

export type CardsParentSetFailureAction = {
	type: typeof CARDS_PARENT_SET_FAILURE;
	meta: OptimisticUiMetaWithFlag;
};

export const cardsParentSetFailure = (optimisticId: string): CardsParentSetFailureAction => ({
	type: CARDS_PARENT_SET_FAILURE,
	meta: revertOptimisticUiWithFlagMeta(optimisticId),
});

export type Action =
	| CardsParentSetOptimisticAction
	| CardsParentSetSuccessAction
	| CardsParentSetFailureAction;
